import React, { useState } from 'react';
import { anime } from 'react-anime';
import './InfoBalls.scss';
import modal1 from '../assets/elements/img/tools/tools-analytics.png';
import modal2 from '../assets/elements/img/tools/tools-remote.png';
import modal3 from '../assets/elements/img/tools/tools-tools.png';
import modal4 from '../assets/elements/img/tools/tools-recruiting.png';
import modal5 from '../assets/elements/img/tools/tools-ai.png';

export default ({ isActive }) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeModal, setActiveModal] = useState(0);
  let images = [modal1, modal2, modal3, modal4, modal5];
  const infoBallData = [
    { 
      title: 'Predictive Analytics',
      copy: 'One of the most exciting innovations in science today is the use of predictive algorithms, like those used in SENSE, the Novartis clinical trial control center. SENSE is a digitally-powered advancement in using data to help clinical trial teams predict problems before they start so they can run better, more efficient clinical trials.',
      slug: 'predictive-analytics',
      img: modal1
    },
    { 
      title: 'Remote Monitoring',
      copy: 'Virtual visits with patients and trial sites have enabled Novartis investigators to continue to run clinical trials safely during a pandemic. These tools could help researchers design clinical trials that are both more efficient to run and more convenient for patients in the future. ',
      slug: 'remote-monitoring',
      img: modal2
    },
    { 
      title: 'Digital Measures',
      copy: 'Novartis scientists are using digital tools, such as measuring brain waves to understand neurodegeneration or using smartphones to assess activity, to learn more about how patients are doing not only in terms of their disease, but also in terms of quality of life.',
      slug: 'digital-measures',
      img: modal3
    },
    { 
      title: 'Digital Recruiting',
      copy: 'Digital tools are enabling Novartis investigators to meet patients where they are, at home, online and looking for potential new ways to address their medical concerns. The Novartis online clinical trial resource center can help inform patients and direct them to learn more about available trials.',
      slug: 'digital-recruiting',
      img: modal4
    },
    { 
      title: 'Artificial Intelligence',
      copy: 'Novartis researchers are using artificial intelligence (AI) to analyze information from their clinical trials. AI could detect hidden but informative patterns that could help scientists understand why some patients respond to an experimental therapy when other seemingly similar patients do not.',
      slug: 'artificial-intelligence',
      img: modal5
    },
  ]

  const openModal = index => {
    const fadeInModal = anime({
      targets: '.modal',
      opacity: [
        { value: 0, duration: 0, },
        { value: 1, duration: 500, easing: 'linear' }
      ],
    })
  
    setActiveModal(index);
    fadeInModal.play();
    setIsModalOpen(true);
  }

  const closeModal = () => setIsModalOpen(false);

  const BubbleComponent = ({ bubble, index }) => (
    <div className="outer-circle" onClick={() => openModal(index)}>
      <div>
        <div className="inner-bubble" style={{background: `url(${bubble.img})`, backgroundSize: 'cover'}}>
          <div className="inner-bubble-mask"></div>
          <p>{bubble.title}</p>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className={`modal ${isModalOpen ? 'modal-opened' : ''}`}>
        <div className="outer-modal" onClick={() => closeModal()}></div>
        <div className="inner-modal">
          <span className="close" onClick={() => closeModal()}>X</span>
            <div className="modal-image-container"><img src={images[activeModal]} alt="tools" /></div>
            <div className="modal-text-container">
              <p>{infoBallData[activeModal].title}</p>
              <p className="copy">{infoBallData[activeModal].copy}</p>
            </div>
        </div>
      </div>
      
      <div className="info-balls-container">
        <div className="title-bar">
          <p className="secondary-large">Examples of state-of-the-art tools used to collect data include:</p>
        </div>
        <div className="cols">
          <div className="col">
            <BubbleComponent bubble={infoBallData[0]} index={0} />
            <BubbleComponent bubble={infoBallData[1]} index={1} />
          </div>
          <div className="col">
            <BubbleComponent bubble={infoBallData[2]} index={2} />
          </div>
          <div className="col">
            <BubbleComponent bubble={infoBallData[3]} index={3} />
            <BubbleComponent bubble={infoBallData[4]} index={4} />
          </div>
        </div>
      </div>
    </>
  );
};